import * as React from "react";
import Svg, { Rect, G, Circle, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill="#F3F5FC" />
    <G clipPath="url(#clip0_2951_12293)">
      <G clipPath="url(#clip1_2951_12293)">
        <Circle cx={21} cy={21} r={9} fill="#1434CB" fillOpacity={0.1} />
        <Path
          d="M25.1016 17.7715H29.9873V12.8857"
          stroke="#1434CB"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M29.9872 17.7714L27.1087 14.8929C25.4416 13.226 23.1846 12.2834 20.8272 12.2697C18.4697 12.256 16.2019 13.1722 14.5156 14.8196"
          stroke="#1434CB"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M16.9585 24.2859H12.0728V29.1716"
          stroke="#1434CB"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12.0728 24.2859L14.9513 27.1644C16.6183 28.8314 18.8753 29.7739 21.2327 29.7876C23.5902 29.8014 25.858 28.8851 27.5443 27.2377"
          stroke="#1434CB"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Path
        d="M23.6123 19.0625L23.3226 20.0512H17.7998L18.0896 19.0625H23.6123ZM21.0214 25.7273L17.9021 21.9091L17.885 21.1932H19.4362C19.8396 21.1932 20.1833 21.1364 20.4674 21.0227C20.7515 20.9063 20.9689 20.733 21.1194 20.5029C21.27 20.2699 21.3453 19.9773 21.3453 19.625C21.3453 19.1051 21.189 18.6975 20.8765 18.402C20.564 18.1037 20.0839 17.9546 19.4362 17.9546H17.7998L18.0896 17H19.4362C20.1294 17 20.6975 17.1151 21.1407 17.3452C21.5868 17.5724 21.9163 17.8849 22.1294 18.2827C22.3453 18.6776 22.4532 19.125 22.4532 19.625C22.4532 20.0767 22.3538 20.4929 22.1549 20.8736C21.9589 21.2514 21.6436 21.5554 21.2089 21.7855C20.7771 22.0157 20.2061 22.1307 19.4958 22.1307H19.4703L22.351 25.6591V25.7273H21.0214ZM23.6123 17L23.3226 17.9886L18.9759 17.9546L19.2657 17H23.6123Z"
        fill="#1434CB"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_2951_12293">
        <Rect width={24} height={24} fill="white" transform="translate(9 9)" />
      </ClipPath>
      <ClipPath id="clip1_2951_12293">
        <Rect
          width={26.0573}
          height={26.0573}
          fill="white"
          transform="translate(8 8)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
